import { ManageVehicleDriverFormComponent } from "./manage-vehicle-driver-form/manage-vehicle-driver-form.component";
import { ManageVehicleDriverComponent } from "./manage-vehicle-driver.component";
import { ViewManageVehicleDriverComponent } from "./view-manage-vehicle-driver/view-manage-vehicle-driver.component";
// import { ManageMenuComponent } from "./directive/manage-menu-component";
import { UnAssignVehicleComponent } from "./unassign-vehicle/unassign-vehicle-component";
import { UnAssignDriverComponent } from "./unassign-driver/unassign-driver-component";
import { AssignVehicleComponent } from "./assign-vehicle/assign-vehicle-component";

export const ManageVehicleDriverDeclaration = [
    ManageVehicleDriverComponent,
    ManageVehicleDriverFormComponent,
    ViewManageVehicleDriverComponent,
    UnAssignVehicleComponent,
    UnAssignDriverComponent,
    AssignVehicleComponent
];
